export const values = [
  {
    icon: "ri-sword-line",
    title: "Elite Excellence",
    desc: "We set the gold standard in game development and guild operations, delivering products that lead the industry.",
  },
  {
    icon: "ri-team-line",
    title: "Community First",
    desc: "Every decision we make is driven by the needs of our players, guilds, and partners. Community is our core.",
  },
  {
    icon: "ri-rocket-line",
    title: "Relentless Innovation",
    desc: "We push boundaries with cutting-edge technologies, from Web3 gaming to AI-powered social platforms.",
  },
  {
    icon: "ri-global-line",
    title: "Global Reach",
    desc: "Operating across Southeast Asia and beyond, we connect gaming communities on a global scale.",
  },
];

export const milestones = [
  { year: "2016", title: "Founded", desc: "AWWAL Marine & Engineering established in Malaysia with a vision for digital entertainment." },
  { year: "2018", title: "First Game Launch", desc: "Released our debut mobile RPG, reaching 50,000 downloads in the first 30 days." },
  { year: "2020", title: "Guild Platform", desc: "Launched proprietary guild management platform serving 50+ gaming communities." },
  { year: "2022", title: "Web3 Expansion", desc: "Entered the blockchain gaming space, developing NFT-integrated game economies." },
  { year: "2024", title: "200K+ Players", desc: "Surpassed 200,000 active players across all platforms and partner networks." },
  { year: "2026", title: "Global Scale", desc: "Expanding into new markets with next-gen social gaming infrastructure." },
];

export const team = [
  {
    name: "Ahmad Razif",
    role: "CEO & Co-Founder",
    desc: "Visionary leader with 12+ years in gaming and technology entrepreneurship.",
    avatar: "https://public.readdy.ai/ai/img_res/fc5c3958ec922d2f801f16d0aee7548c.jpg",
  },
  {
    name: "Lena Tan",
    role: "Head of Game Development",
    desc: "Award-winning game designer with credits in 20+ published titles.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20game%20developer%20creative%20director%20portrait%20studio%20dark%20background%20Asian%20woman%20technology&width=300&height=300&seq=team2&orientation=squarish",
  },
  {
    name: "Marcus Ho",
    role: "Guild Operations Director",
    desc: "Former esports athlete turned operations expert, managing 300+ guild partnerships.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20esports%20director%20portrait%20dark%20background%20gaming%20industry%20executive%20Asian%20man%20mid%2030s&width=300&height=300&seq=team3&orientation=squarish",
  },
  {
    name: "Priya Sharma",
    role: "CTO",
    desc: "Engineering powerhouse specializing in scalable cloud infrastructure for gaming.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20CTO%20technology%20leader%20portrait%20studio%20dark%20background%20Indian%20woman%20engineer%20executive&width=300&height=300&seq=team4&orientation=squarish",
  },
];
